export default __webpack_public_path__ + "static/3-fitness-21e7542e848938b04c61cba975d208e5.png";